export default __webpack_public_path__ + "static/media/slider-4.503bae7d.png";